import React from 'react';
import { SiteHeader } from './SiteHeader';

/**
 * CalculatorTopNav — thin shim around `<SiteHeader />`.
 *
 * Previously this component rendered its own two-tier utility + nav bar
 * used by the Inheritance / Will / Article / Guide pages. It has been
 * retired in favor of `SiteHeader`, which is the single, shared, one-row
 * (~64 px) navigation used on the homepage.
 *
 * Retaining this component (and re-exporting `SiteHeader` under its old
 * name) means the ~8 existing call sites (`ArticlePage`, `GuidePages`,
 * `InheritancePage`, `WillPage`, `ZakatCalculatorPage`, `PageShell`, etc.)
 * keep working without modification. All legacy props (`highlight`,
 * `title`, `labels`, `selectedCountry`, `selectedLanguage`, `countries`,
 * `languages`, `updateCountry`, `updateLanguage`, `testidPrefix`) are
 * intentionally ignored — the new header derives everything from the
 * global context so every page renders the exact same shell.
 */
export const CalculatorTopNav = () => <SiteHeader />;

export default CalculatorTopNav;
